import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { useDateRange } from "../../../../common/components/datePicker/modelsDatePickers";
import { useCustomerIdGuard } from "../../../../common/hooks/useCustomerIdGuard";
import { useSelectedLocation } from "../../../../common/variables/selectedLocation";
import { useSelectedDataHubCamera } from "../../../data-hub/components/dataHub.variable";
import EventPageTitle from "../../../recent-activities/components/EventPageTitle";
import RecentActivitiesFilters from "../../../recent-activities/components/RecentActivitiesFilters";
import EventTableContainer from "../../../recent-activities/components/table/EventTableContainer";
import { HARDHAT_SELECT_OPTION } from "../../../recent-activities/hooks/export/useGetEventsToExport";

const SafetyEventsServerTableContainer = () => {
  const customerId = useCustomerIdGuard();
  const facilityId = useSelectedLocation();
  const cameraVariable = useSelectedDataHubCamera();
  const dateRange = useDateRange();

  const modelId = HARDHAT_SELECT_OPTION;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1em",
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <EventPageTitle title="Hard Hat events" />
        </Grid>

        <RecentActivitiesFilters
          showModelFilter={false}
          showDeviceFilter
          showLocationTags
        />
      </Grid>

      <EventTableContainer
        customerId={customerId}
        modelId={modelId}
        facilityId={facilityId}
        cameraId={cameraVariable?.value}
        dateRange={dateRange}
      />
    </Box>
  );
};

export default SafetyEventsServerTableContainer;
